import $ from 'jquery';

/**
 * Show/Hide the State field depending on the country...
 */
class CountryCheck {
    constructor () {
        const $addressCountryInput = $('.js-address-country input');

        // Code below will strip symbols and lowercase all strings
        const usaCheckValues = [
            'us',
            'usa',
            'united states',
            'united states of america',
            'america'
        ];

        // Check on load (for prefilled forms)
        $addressCountryInput.each(function () {
            const $closestAddressState = $(this).closest('.js-address-wrapper').find('.js-address-state');

            // Show the state if the field has an error.
            if ($closestAddressState.find('.u-warning').length) {
                CountryCheck.showState($closestAddressState);
            }

            // Show the state if the country is USA.
            if (usaCheckValues.indexOf(CountryCheck.getSanitizedVal($(this))) > -1) {
                CountryCheck.showState($closestAddressState);
            }
        });

        // Check on field change
        $addressCountryInput.on('change keyup', function () {
            const $closestAddressState = $(this).closest('.js-address-wrapper').find('.js-address-state');

            if (usaCheckValues.indexOf(CountryCheck.getSanitizedVal($(this))) > -1) {
                CountryCheck.showState($closestAddressState);
            } else {
                CountryCheck.hideState($closestAddressState);
            }
        });
    }

    static showState ($elem) {
        $elem.show();
        $elem.find('select').attr('required', 'required');
    }

    static hideState ($elem) {
        $elem.hide();
        $elem.find('select').removeAttr('required').val('');
    }

    static getSanitizedVal ($elem) {
        return $elem.val().toLowerCase().replace(/[_\W]+/g, '');
    }
}

export default CountryCheck;
